import store from '@/store'
export default {
  data() {
    return {
      tableHeight: ''
    }
  },
  watch: {
    dialogVisible(val) {
      // 窗口发生变化的时候
      let me = this
      window.onresize = () => {
        return (() => {
          me.comptedTableHeight()
        })()
      }
      if (val) {
        this.comptedTableHeight()
      }
    }
  },
  methods: {
    // 表头颜色
    theme() {
      let themeColor = store.state.settings.theme
      return themeColor
    },
    // 计算表格高度
    comptedTableHeight() {
      this.$nextTick(() => {
        let dialogHeight = this.$refs.dialog.$el.querySelector('.el-dialog__body').clientHeight
        let searchConditionHeight = this.$refs.searchCondition ? (this.searchHeight ? this.searchHeight : 28) : 0
        let tableOptionEl = this.$refs.tableOperation
        let tableOptionHeight = tableOptionEl ? 60 : 0
        let fixedHeight = this.isPaging ? 25 : 0
        let tabsHeight = this.isTabs ? 60 : 0
        if (this.$refs.searchCondition && !tableOptionEl) {
          this.tableHeight = dialogHeight - searchConditionHeight - fixedHeight - tableOptionHeight - tabsHeight - 45 + 'px'
        } else if (!this.$refs.searchCondition && !tableOptionEl) {
          this.tableHeight = dialogHeight - searchConditionHeight - fixedHeight - tableOptionHeight - tabsHeight - 30 + 'px'
        } else if (tableOptionEl && !this.$refs.searchCondition) {
          this.tableHeight = dialogHeight - searchConditionHeight - fixedHeight - tableOptionHeight - tabsHeight - 15 + 'px'
        } else {
          this.tableHeight = dialogHeight - searchConditionHeight - fixedHeight - tableOptionHeight - tabsHeight - 25 + 'px'
        }
      })
    },
    // 查询
    searchData(tableName, tableMark) {
      // 重置右键筛选条件
      tableName.tableQuery.page = 1
      tableName.tableQuery.contextmenuWrap = []
      // 重置排序条件
      tableName.tableQuery.sort.order = ''
      // this.$refs[tableName.tableKey].$children[0].clearSort()
      this.loadTableData(tableName, tableMark)
    },
    // 加载数据
    loadTableData(tableName, tableMark) {
      // 缓存查询条件
      sessionStorage.setItem(tableName.tableKey + '_' + tableName.tableIndex, JSON.stringify(tableName.tableQuery))
      tableName.tableIndex++
      // 请求数据
      this.requestData(tableMark)
    },
    // 处理数据序号及没有查询到数据
    handleData(obj, data) {
      if (data.length > 0) {
        let pageStart = (obj['tableQuery']['page'] - 1) * obj['tableQuery']['limit']
        data.forEach((item, index) => {
          item['rowNumber'] = Number(pageStart) + Number(index) + 1
        })
        obj['tableData'] = data
      } else {
        obj['tableData'] = []

        this.$message({
          dangerouslyUseHTMLString: true,
          message: `<div class="empty-tip" >${this.$t('messageTip.nothing')}</div>`,
          customClass: 'empty'
        })
        this.setMessagePos()
      }
    },
    // 设置无数据里消息提示框的位置
    setMessagePos() {
      let box = document.getElementsByClassName('empty')[0]
      let clientHeight = document.body.clientHeight || document.documentElement.clientHeight
      box.style.top = (clientHeight - 50) / 2 + 'px'
    }
  }
}
